// extracted by mini-css-extract-plugin
module.exports = {"paddingBottom":"DownloadBoard_paddingBottom__1VqiL"};